<template>
  <fragment>
    <a ref="attachmentA"></a>
    <div class="email-rightbar card" v-if="email != null && linkEmail">
      <div class="card-header">
        <ul class="list-inline mb-0">
          <li class="list-inline-item">
           
            <h5 class="mt-2 mb-0">{{ email.subject }}</h5>
          </li>
          <li class="list-inline-item float-right">
            <button
              class="btn btn-link"
              @click="email=null"
              title="Chiudi"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card m-b-30">
            <div class="card-header">
              <h5 class="card-title mb-0">Filtri</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <input
                    type="text"
                    v-model="cquery"
                    class="form-control"
                    placeholder="Codice/ragione sociale/telefono/email"
                  />
                </div>
                <div class="col-4">
                  <select class="form-control" v-model="cstate">
                    <option value="">In corso</option>
                    <option value="Invoced">Fatturate</option>
                  </select>
                </div>

                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary-rgba mr-2"
                    v-on:click="loadContracts"
                  >
                    <i class="feather icon-filter mr-2"></i>Filtra
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card m-b-30">
            <div class="card-body">
              <table
                ref="table"
                id="list-emailcontract-table"
                class="table table-hover w-100"
              ></table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="card email-open-box m-b-30"
      v-if="email != null "
    >
      <div class="card-header">
        <ul class="list-inline mb-0">
          <li class="list-inline-item">
          
            <h5 class="mt-2 mb-0">{{ email.subject }}</h5>
          </li>
          <li class="list-inline-item float-right">
            <button
              class="btn btn-link"
              @click="destroyEmail"
              title="Chiudi anteprima"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="row m-b-30">
          <div class="col-md-5">
            <div class="media">
              <div class="media-body">
                <h6>Da:</h6>
                <h6 class="mt-0">{{ email.displayName }}</h6>
                <span class="text-muted mb-0">{{ email.emailFrom}}</span
                ><br /><br />
                <h6>A:</h6>
               {{email.emailTo}}
                <br />
              </div>
            </div>
          </div>

          <div class="col-md-7 text-right">
            <div class="open-email-head">
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  {{ email.date | formatFullDate }}
                </li>
                <li class="list-inline-item">
                 
                </li>
                <li class="list-inline-item">
                 
                </li>
                <li class="list-inline-item">
                 
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <iframe
              frameborder="0"
              name="iframepreview"
              id="iframepreview"
              class="b-0 w-100"
            />
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-3"
            v-for="item in email.attachments"
            :key="item.attachmentId"
          >
            <div class="card border-light m-b-30">
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col-9">
                    <span class="badge badge-pill badge-light">{{
                      item.fileExtension
                    }}</span>
                  </div>
                  <div class="col-3">
                    <div class="dropdown">
                      <button
                        class="btn btn-link l-h-20 p-0 font-18 float-right"
                        type="button"
                        id="CustomdropdownMenuButton8"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="feather icon-more-horizontal-"></i>
                      </button>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="CustomdropdownMenuButton8"
                      >
                        <button
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            downloadAttachment(email.id, item.originalFileName)
                          "
                        >
                          <i class="feather icon-download-cloud"></i> Download
                        </button>
                        <button
                          v-if="value"
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            setAttachemnt(email.id, item.originalFileName)
                          "
                        >
                          <i class="feather icon-edit"></i> Associa
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <i
                      class="card-img-top fa-4x text-center p-1"
                      src=""
                      alt=""
                      :class="getExtensionIcon(item.fileExtension)"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <h6 class="cart-title attachment-filename" :title="item.title">
                  <button
                    class="btn btn-link"
                    v-on:click.stop="
                      downloadAttachment(email.id, item.originalFileName)
                    "
                  >
                    {{ item.originalFileName }}
                  </button>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>

    <div class="email-rightbar" v-if="email == null">
      <div class="card m-b-30">
        <div class="card-header row">
          <div class="col-10">
            <h4 class="page-title">Comunicazioni</h4>
          </div>
          <div class="col-2 text-right">
            <button
              title="Aggiorna"
              type="button"
              class="btn btn-round btn-primary-rgba"
              @click="loaddata"
            >
              <i class="feather icon-refresh-cw"></i>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="row mb-5">
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                placeholder="Oggetto/mittente"
                v-model="emailFilter"
                v-on:change="loaddata"
              />
            </div>
          
          </div>

          <div class="table-responsive">
            <table
              ref="table"
              id="list-inboxemail-table"
              class="table table-hover table-borderless w-100"
            ></table>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import * as srcDoc from "srcdoc-polyfill";
import axios from "axios";

export default {
  name: "mailmessagelist",

  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      entities: [],
      email: null,
      emailFilter: "",
      processed: "",
      archived: "0",
      linkEmail: false,
    };
  },
  components: {},
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {

    destroyEmail: function(){
this.email = null;
setTimeout(this.loaddata,100);

    },
    getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text";
        case ".doc":
        case ".docx":
          return "fa fa-file-word  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    setAttachemnt: function (id, o) {
      var me = this;
      axios.get(`contract/attachmentTypes/${this.value}`).then((response) => {
        me.$swal({
          title: `Associare il file ad una tipologia`,
          text: "",
          type: "question",
          input: "select",
          inputOptions: response.data,
          showCancelButton: false,
          confirmButtonClass: "btn-danger-rgba",
          confirmButtonText: "Associa",

          inputValidator: (value) => {
            return new Promise((resolve) => {
              axios
                .post("inboxemail/saveattachment", {
                  id: id,
                  type: value,
                  filename: o,
                })
                .then((result) => {
                  resolve();
                  me.$emit("update");
                })
                .catch(() => {
                  resolve("Ops, qualcosa è andato storto");
                });
            });
          },
        });
      });
    },
    downloadAttachment: function (id, o) {
      var me = this;
      var url = "";

      axios
        .post(
          `inboxemail/downloadattachment`,
          { id: id, fileName: o },
          { responseType: "blob" }
        )
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },

    previewEmail(id) {
      var me = this;
      me.linkEmail = false;
      var tempmail = null;
      if ($.fn.DataTable.isDataTable("#list-emailcontract-table")) {
        $("#list-emailcontract-table").DataTable().destroy();
      }

      axios.get(`mailmessage/${id}`).then((response) => {
        me.email = response.data;
         setTimeout(function () {
         $("#iframepreview").attr("srcdoc", me.email.body);
              setTimeout(function () {
                $("#iframepreview")[0].style.height =
                  $("#iframepreview")[0].contentWindow.document.documentElement
                    .scrollHeight + "px";
              }, 200);
         },200);
        
      });
    },

    loaddata: function () {
      if ($("#list-inboxemail-table").length == 0) {
        setTimeout(this.loaddata, 100);
        return;
      }
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-inboxemail-table")) {
        $("#list-inboxemail-table").DataTable().destroy();
      }
      me.email = null;

      var $table = $("#list-inboxemail-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url:
            window.SETTINGS.apiUrl +
            "/mailmessage/list/" +
            (me.value ? me.value : ""),
          type: "POST",
          data: function (d) {
            d.search.value = me.emailFilter;
            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },
        createdRow: function (row, data, dataIndex) {
          $(row).data("id", data.mailMessageId);
        },
        columns: [
          {
            data: "mailMessageId",
            name: "",
            title: "Mittente",
            render: function (data, type, row, meta) {
              var badge=""
              switch (row.status) {
                case "None":

                  default:
                  break;
                case "Sending":
                  badge =`<span class="badge badge-warning mr-2">In Spedizione</span><br/>`
                  break;
                case "Sent":
                    badge =`<span class="badge badge-success mr-2">Spedita</span><br/>`
                  break;
                case "Retry":
                    badge =`<span class="badge badge-warning mr-2">In rispedizione</span><br/>`
                  break;
                case "Error":
                    badge =`<span class="badge badge-danger mr-2">Errore</span><br/>`
                  break;
                case "Paused":
                    badge =`<span class="badge badge-warning mr-2">In pausa</span><br/>`
                  break;
                case "Cancelled":
                    badge =`<span class="badge badge-danger mr-2">Annullata</span><br/>`
                  break;

              
                case "InvalidEmail":
                    badge =`<span class="badge badge-danger mr-2">Mail non valida</span><br/>`
                  break;
              }

              if (row.displayName != "") {
                return `${badge}${row.displayName}<br/><small class="text-muted">(${row.emailFrom})</small>`;
              } else {
                return badge+row.emailFrom;
              }
            },
          },
          {
            data: "mailMessageId",
            name: "",
            title: "Destinatario",
            render: function (data, type, row, meta) {
              //          var output =
              //                                `<div class="row">
              //<div class="col">
              //<p>${row.name}</p>

              //</div>`

              return row.emailTo;
            },
          },
          {
            data: "subject",
            name: "",
            title: "Oggetto",
            render: function (data, type, row, meta) {
              return row.subject;
            },
          },
          {
            data: "subject",
            name: "date",
            title: "Data",
            render: function (data, type, row, meta) {
              return me.$options.filters.formatFullDate(row.insertDate);
            },
          },
        ],
      });
      $("#list-inboxemail-table").on("click", "tr", function () {
        var data = $table.row(this).data();

        me.previewEmail($(this).data("id"));
      });
    },

    searchContracts: function () {
      this.linkEmail = true;
      setTimeout(this.loadContracts, 200);
    },
    setContract: function (id) {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler associare questa mail?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post(`inboxemail/link/${me.email.id}/${id}`)
            .then((response) => {
              me.$swal({
                title: "Associazione avvenuta correttamente",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

              me.email = null;
              setTimeout(me.loaddata, 200);
            });
        }
      });
    },
    loadContracts: function () {
      var me = this;
      window.setContract = me.setContract;
      if ($.fn.DataTable.isDataTable("#list-emailcontract-table")) {
        $("#list-emailcontract-table").DataTable().destroy();
      }

      var $ctable = $("#list-emailcontract-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/contract/list",
          type: "POST",
          data: function (d) {
            d.search.value = me.cquery;

            d.filters = [{}];

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "contractId",
            name: "contractId",
            title: "Ragione sociale",
            render: function (data, type, row, meta) {
              var retval = `
              <span class="badge badge-primary">${me.$options.filters.contractState(
                row.state
              )}</span> <span class="badge badge-success capitalize">${
                row.procedureId
              }</span> <span class="badge badge-info capitalize">${
                row.ransomId
              } ${row.subRansomId}</span>
              <h4>${row.code} </h4>
              <h5>${row.companyName}</h5>
              `;
              return retval;
            },
          },
          {
            className: "text-right",
            data: "contractId",
            name: "contractId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.setContract('${row.contractId}')"><i class="feather icon-link"></i></button>
                                   `;
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}

#list-inboxemail-table thead {
  display: none;
}
</style>
